import { Vue, Component } from 'vue-property-decorator'
import { ApiException } from '@/services/connecteur'
import { ToastOptions } from 'vue-toasted'
import { TranslateResult } from 'vue-i18n'

@Component
export default class BaseVue extends Vue {
  private toastConfig: ToastOptions = {
    theme: 'toasted-primary',
    position: 'bottom-center',
    duration: 7000,
    action: {
      text: 'X',
      onClick: (e: any, toastObject: any) => {
        toastObject.goAway(0)
      }
    }
  };

  public displayError (error: ApiException | string | TranslateResult | unknown) {
    let text = ''
    if (error) {
      if (typeof error === 'string') {
        text = error
      } else if (error as ApiException) {
        const ex = error as ApiException
        text = ex.response
        if (ex.status === 401 || ex.status === 403) {
          text = this.$t('errors.unauthorized').toString()
        } else if (ex.response == null) {
          text = this.$t('errors.serverDown').toString()
        }
      } else {
        text = `${error}`
      }
    }
    this.$toasted.error(text, this.toastConfig)
  }

  public displayMessage (text: string | TranslateResult) {
    this.toastConfig.type = 'info'
    this.$toasted.show(text.toString(), this.toastConfig)
  }
}
